export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14744.a6d49475.jpg";